module.exports = __webpack_public_path__ + "static/img/gyl.1dbd6c4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gyl.jpg
// module id = kI2n
// module chunks = 1